import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Col, Row, notification } from 'antd'
import { Form, Formik } from 'formik'

import {
  ReimbursementCategoriesTypeValues,
  getAvailableReimbursementCategories,
  saveRestrictedReimbursementCategories,
} from 'core/application/adminDashboard/benefitDetails/design/restrictReimbursementCategories'

import Option from 'common/components/dataEntry/components/Option'

import { commandRequest, queryRequest } from 'common/RequestUtils'

import Select from '../../../../common/components/dataEntry/formik/FormikDefaultSelectField'
import { BaseComponentProps } from '../../../../employeeSignup/common/models'

const RestrictReimbursementCategories: React.FC<BaseComponentProps<ReimbursementCategoriesTypeValues>> = (props) => {
  const { bindSubmitFormHandler } = props
  const initialValues: ReimbursementCategoriesTypeValues = { ...props.state }
  const { planPeriod } = useParams<any>()

  const { t: translate } = useTranslation()
  const [availableCategories, setavAilableCategories] = useState([])

  useEffect(() => {
    ;(async () => {
      let result = await queryRequest(() => getAvailableReimbursementCategories())
      setavAilableCategories(result)
    })()
    props.setIsFormValid(true)
  }, [])

  const onSubmit = async (values: ReimbursementCategoriesTypeValues) => {
    let request: ReimbursementCategoriesTypeValues = {
      planPeriodId: planPeriod,
      restrictedExpenseCategories: values.restrictedExpenseCategories,
    }
    const res = await commandRequest(() => saveRestrictedReimbursementCategories(request))
    if (!res.errors) {
      props.goNext()
    } else {
      props.setIsSubmiting(false)
      notification.open({
        message: res.errors[0],
        type: 'error',
      })
    }
  }
  return (
    <Formik enableReinitialize={true} initialValues={initialValues} onSubmit={onSubmit}>
      {(formik) => {
        const { submitForm } = formik
        bindSubmitFormHandler(submitForm)
        return (
          <Form>
            <Row justify={'center'}>
              <Col sm={24} lg={18} className="benefit_design_page_header">
                <h5>{translate('admin-dashboard.benefit-details.restrict-reimbursement-categories')}</h5>
              </Col>
            </Row>
            <Row justify={'center'} className="form__row">
              <Col sm={24} lg={18}>
                <Select
                  label={translate('admin-dashboard.benefit-details.restrict-reimbursement-categories')}
                  placeholder={translate('admin-dashboard.benefit-details.restrict-reimbursement-categories')}
                  name="restrictedExpenseCategories"
                  // defaultValue={props.state.restrictedExpenseCategories}
                  mode="multiple"
                  size="large"
                >
                  {availableCategories?.map((c: any) => (
                    <Option key={c.id} value={c.id}>
                      {c.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </Form>
        )
      }}
    </Formik>
  )
}

export default RestrictReimbursementCategories
